//styles js
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@material-ui/core";

const drawerWidth = 260;
const miniDrawer = 80;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    position: "relative",
  },
  appBar: {
    // zIndex: theme.zIndex.drawer + 1,
    background: "#f8f8f8",
    border: "none",
    color: "var(--itsm-bg-btn)",
    height: "69px",
  },
  drawer: {
    flexShrink: 0,
    paddingTop: "20px",
    width: "250px",
  },
  minidrawer: {
    width: miniDrawer,
    border: "none",
  },
  drawerPaper: {
    width: drawerWidth,
    border: "none",
  },
  drawerContainer: {
    overflow: "auto",
  },
  SettingBar: {
    position: "absolute",
    right: "0",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: 'hidden',
    height: 'auto',
    maxHeight: '5000px',
    background: 'var(--itsm-bg-color) !important',
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  root1: {
    justifyContent: "left",
  },
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: colors.blueGrey[800],
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
  },
  btnRoot: {
    paddingLeft: "25px",
    justifyContent: "left !important",
  },
  subMenu: {
    paddingLeft: "50px !important",
  },
  SettingContanier: {
    position: "absolute",
    right: 0,
    left: 0,
    top: 0,
    /* width: 100% !important; */
    bottom: 0,
    background: "rgba(0, 0, 0, 0.3)",
    zIndex: "2000",
    // '&:hover': {
    //     display: 'none'
    // }
  },
  Setting: {
    zIndex: "1110 !important",
    top: "0",
    right: "0",
    position: 'fixed',
    overflowY : "hidden", 
    maxWidth: "100%",
    height: "100%"
  },
  UnSetting: {
    display: "none",
  },
  ImageBox: {
    cursor: 'pointer'
  },
  ImageItemSetting: {
    '&:hover': {
      border: '1px solid #f54403',
      padding: '2px',
    }
  }
}));
